import { render, staticRenderFns } from "./PanelMenuItem.vue?vue&type=template&id=26d2b5bc&"
import script from "./PanelMenuItem.vue?vue&type=script&lang=ts&"
export * from "./PanelMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports